import {
  Button,
  ButtonGroup,
  Content,
  Dialog,
  Divider,
  Heading,
  useDialogContainer,
  TextField,
  Flex,
  Text,
} from "@adobe/react-spectrum";
import React, { useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import PropTypes from "prop-types";
import {
  error as ErrorToast,
  success as SuccessToast,
} from "@react/react-spectrum/Toast";
import { gtmhApi } from "../../../../api/gtmhApi";
import useUserProfile from "../../../../context/user-context";

export default function PromoteSubDialog({
  rowInfo,
  status,
  refreshTable,
  isPageLoading,
  setPageLoading,
}) {
  const { user } = useUserProfile();
  const { authState } = useOktaAuth();

  const [promoteRequest, setPromoteRequest] = useState({
    sub_id: rowInfo.sub_id,
    comment: "",
    user_id: user?.userId,
    user_name: user?.name,
    status,
  });
  const [errorMessage, setErrorMessage] = useState("");

  const dialog = useDialogContainer();

  const handlePromote = () => {
    setPageLoading(true);
    gtmhApi
      .promoteSub(promoteRequest, authState.accessToken)
      .then((data) => {
        if (data.results?.results) {
          dialog.dismiss();
          refreshTable();
          setPageLoading(false);
          SuccessToast(`Successfully promoted sub ${rowInfo.sub_id}!`, {
            timeout: 5000,
          });
        } else {
          setPageLoading(false);
          setErrorMessage(data.results?.error_payload.message);
        }
      })
      .catch((error) => {
        console.log("error");
        dialog.dismiss();
        setPageLoading(false);
        ErrorToast(error.response?.data?.message || "Error promoting parent", {
          timeout: 5000,
        });
      });
  };

  const handleCancel = () => {
    dialog.dismiss();
  };

  return (
    <Dialog>
      <Heading>{`Promote Sub: ${rowInfo.subsidiary_name}`}</Heading>
      <Divider />
      <Content>
        {errorMessage !== "" && (
          <Text UNSAFE_style={{ color: "red" }}>{errorMessage}</Text>
        )}
        <Flex marginBottom="15px">
          Promoting this sub will results in a new parent being create with the
          same attributes. Proceed to promote?
        </Flex>
        <TextField
          label="Comment"
          width="100%"
          onChange={(val) =>
            setPromoteRequest({ ...promoteRequest, comment: val })
          }
          marginTop="10px"
        />
      </Content>
      <ButtonGroup>
        <Button onPress={handleCancel} variant="secondary">
          Cancel
        </Button>
        <Button
          onPress={handlePromote}
          color="primary"
          variant="accent"
          isDisabled={isPageLoading}
        >
          Promote
        </Button>
      </ButtonGroup>
    </Dialog>
  );
}

PromoteSubDialog.propTypes = {
  rowInfo: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.array,
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.object),
    ])
  ).isRequired,
  status: PropTypes.string.isRequired,
  refreshTable: PropTypes.func.isRequired,
  setPageLoading: PropTypes.func.isRequired,
  isPageLoading: PropTypes.bool.isRequired,
};
